// Why a receiver connection is in error, as the admin contract carries it: the receiver's stable
// code, the detail the code allows and the trace id of the write that recorded it.
import { Schema } from 'effect';
import { TraceId } from '@finnest/core/effect';

/**
 * Why a connection is in error (receiver CONNECTION_ERROR_CODES): its authorization could not
 * start, its code exchange failed, the transmitter refused it, the consent check found a state the
 * sweep does not act on alone, a sync failed or never finished, or the transmitter serves a TLS
 * certificate the receiver refuses; `unclassified` is a text an earlier release stored.
 */
export const OpinReceiverConnectionErrorCode = Schema.Literals([
  'authorization_initiation_failed',
  'authorization_code_exchange_failed',
  'authorization_refused',
  'consent_anomaly',
  'sync_failed',
  'sync_stalled',
  'transmitter_certificate_not_server',
  'transmitter_certificate_untrusted',
  'transmitter_certificate_wrong_host',
  'unclassified',
]);
export type OpinReceiverConnectionErrorCode = typeof OpinReceiverConnectionErrorCode.Type;

/**
 * A connection's failure as the operator reads it and quotes it to support: the stable code, the
 * detail the code allows (an OAuth error code, a TLS code), and the trace id of the write that
 * recorded it.
 */
export const OpinReceiverConnectionError = Schema.Struct({
  code: OpinReceiverConnectionErrorCode,
  detail: Schema.NullOr(Schema.String),
  traceId: Schema.NullOr(TraceId),
});
export type OpinReceiverConnectionError = typeof OpinReceiverConnectionError.Type;
